import { render, staticRenderFns } from "./LocationMenu.vue?vue&type=template&id=26b6e7a1&scoped=true"
import script from "./LocationMenu.vue?vue&type=script&lang=js"
export * from "./LocationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6e7a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b6e7a1')) {
      api.createRecord('26b6e7a1', component.options)
    } else {
      api.reload('26b6e7a1', component.options)
    }
    module.hot.accept("./LocationMenu.vue?vue&type=template&id=26b6e7a1&scoped=true", function () {
      api.rerender('26b6e7a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/LocationMenu.vue"
export default component.exports